module.exports = __webpack_public_path__ + "static/media/data.19942637.svg";